
export default {
  props: {
    quantityOnSellOrders: {
      type: Number,
      default: 0,
    },
    quantityBlocked: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    showMessages() {
      return this.hasItemsOnSellOrders || this.isPartiallyBlocked
    },

    hasItemsOnSellOrders() {
      return this.quantityOnSellOrders > 0
    },

    itemsOnSellOrdersMessage() {
      return this.$ngettext(
        'You already have %(count)d bottle in a sell order',
        'You already have %(count)d bottles in a sell order',
        this.quantityOnSellOrders,
        {
          count: this.$formatAsNumber(this.quantityOnSellOrders),
        },
      )
    },

    isPartiallyBlocked() {
      return this.quantityBlocked > 0
    },

    partiallyBlockedMessage() {
      return this.$ngettext(
        '%(count)d of your items is blocked and cannot be sold',
        '%(count)d of your items are blocked and cannot be sold',
        this.quantityBlocked,
        {
          count: this.quantityBlocked,
        },
      )
    },
  },
}
